import { commitMutation } from "relay-runtime"
import { chMedicalReportUploadMutation } from "@/modules/patients/services/ch/chMedicalReportUploadMutation"
import { deMedicalReportUploadMutation } from "@/modules/patients/services/de/deMedicalReportUploadMutation"
import { RelayEnvironment } from "@/relay-environment"
import { Country, MedicalReportType } from "@/types/__generated__/union-types"

const deMedicalReportUpload = (
  progressNoteId: string,
  files: File[],
  reportType: MedicalReportType,
  addConnections: string[],
  onCompleted?: VoidFunction,
  onError?: (error: Error | string | undefined) => void,
) =>
  commitMutation(RelayEnvironment, {
    mutation: deMedicalReportUploadMutation,
    variables: { input: { progressNoteId, files, reportType }, addConnections },
    onCompleted,
    onError,
  })

const chMedicalReportUpload = (
  progressNoteId: string,
  files: File[],
  reportType: MedicalReportType,
  addConnections: string[],
  onCompleted?: VoidFunction,
  onError?: (error: Error | string | undefined) => void,
) =>
  commitMutation(RelayEnvironment, {
    mutation: chMedicalReportUploadMutation,
    variables: { input: { progressNoteId, files, reportType }, addConnections },
    onCompleted,
    onError,
  })

type MutationParams = {
  progressNoteId: string
  addConnections: string[]
  files: File[]
  reportType: MedicalReportType
  onCompleted?: () => void
  onError?: (error: Error | string | undefined) => void
}

export const useMedicalReportUpload = (country?: Country) => {
  const handle = (params: MutationParams) => {
    const { addConnections, files, progressNoteId, reportType, onCompleted, onError } = params
    if (country === "DE") {
      return deMedicalReportUpload(progressNoteId, files, reportType, addConnections, onCompleted, onError)
    }
    return chMedicalReportUpload(progressNoteId, files, reportType, addConnections, onCompleted, onError)
  }

  return [handle]
}
